import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {HelmetProvider} from 'react-helmet-async';
import App from './App.tsx';
import './index.css';

// scripts/prerender.mjs bakes a static title/meta description/canonical/OG/
// Twitter set into dist/<route>/index.html so crawlers that never run JS see
// correct per-page tags. react-helmet-async can't detect or remove tags that
// existed before it mounted, so without this it would just add its own set
// alongside the static one — duplicate (though matching) tags in the DOM.
// Strip the static set here, synchronously, before React/Helmet ever run.
document.querySelectorAll(
  'head > title, head > meta[name="description"], head > link[rel="canonical"], head > meta[property^="og:"], head > meta[name^="twitter:"]'
).forEach((el) => el.remove());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>,
);
